import React, { FC, FunctionComponent, Suspense, useEffect } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';

import Loader from 'src/components/widgets/loader';
import { PageHeader } from 'src/components/widgets/pageHeader';
import NotFoundPage from '../components/pages/_notFound';
import administratorRoutes, { AdministratorRoute } from '../shared/administratorRoutes';
import { Center } from '../shared/globals';
import { backofficeUrl, routeMatchUrl, T } from '../shared/helpers';
import { AdmininistratorLayoutContainer } from './administratorLayoutContainer';
import styled from 'styled-components';

const AdminPageBody = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
`;

const AdministratorRouteElement: FC<{ route: AdministratorRoute }> = ({ route }) => {
    const navigate = useNavigate();
    const params = useParams();
    const header = typeof route.header === 'function' ? route.header(params) : route.header;

    return (
        <>
            <PageHeader
                title={header.title}
                description={header.description}
                isBackVisible={!!header.backUrl}
                backLabel={T._('Back', 'Admin')}
                onBackClick={() => {
                    if (header.backUrl) navigate(backofficeUrl(header.backUrl));
                }}
            />
            <AdminPageBody>
                <Suspense
                    fallback={
                        route.skeleton ? (
                            React.createElement(route.skeleton)
                        ) : (
                            <Center>
                                <Loader />
                            </Center>
                        )
                    }
                >
                    {React.createElement(route.component as FC<{}>)}
                </Suspense>
            </AdminPageBody>
        </>
    );
};

const AdministratorLayout: FunctionComponent<{ children?: React.ReactNode }> = () => {
    // Add a class login page to body only on mount and remove it on unmount
    useEffect(() => {
        document.body.classList.add('admin-page');
        return () => {
            document.body.classList.remove('admin-page');
        };
    }, []);

    return (
        <Suspense
            fallback={
                <Center>
                    <Loader />
                </Center>
            }
        >
            <AdmininistratorLayoutContainer>
                <Routes>
                    {administratorRoutes.map((route, index) => {
                        return <Route key={index} path={routeMatchUrl(backofficeUrl(route.url))} element={<AdministratorRouteElement route={route} />} />;
                    })}
                    <Route path='*' element={<NotFoundPage />} />
                </Routes>
            </AdmininistratorLayoutContainer>
        </Suspense>
    );
};

export default AdministratorLayout;
